import axios from '../utils/axios'
// import qs from 'qs'

export function login(data) { 
    // data = qs.stringify(data)
    return axios({
        url: '/api/web/v1/account/login',
        method: 'post',
        data: data
    })
}

export function signup(data) { 
    return axios({
        url: '/api/web/v1/account/register',
        method: 'post',
        data: data
    })
}

//send code
export function sendCode(data) { 
    return axios({
        url: '/api/web/v1/account/captcha/send',
        method: 'post',
        data: data
    })
}
//修改密码
export function setPassword(data) { 
    return axios({
        url: '/api/web/v1/account/password/forgot',
        method: 'post',
        data: data
    })
}
//登出
export function logout(data) { 
    return axios({
        url: '/api/web/v1/account/logout',
        method: 'post',
        data: data
    })
}
//查询用户详情
export function getUserInfo(data) {
    return axios({
        url: '/api/web/v1/account/info',
        method: 'get',
        params: data
    })
}
//sso免密登录
export function ssoLogin(data) {
    return axios({
        url: '/api/web/v1/account/sso/login',
        method: 'post',
        data: data
    })
}